import Requisicao from './RequisicaoService';

class UsuarioService {
    static get(token) {
        return Requisicao.get('usuario/' + token);
    }

    static async remover(id) {
        return Requisicao.delete('usuario/' + id);
    }

    static async cadastro(dados) {                
        return Requisicao.post('usuario', dados);
    }

    static async editar(dados, id) {
        return Requisicao.post('usuario/' + id.toString(), dados);
    }
    
    static async logar(usuario, senha) {        
        return Requisicao.post('logar', {                
            usuario: usuario,
            senha: senha
        });
    }

    static async logout() {           
        return Requisicao.get('logout');
    }

    static async mudarSenha(dados) {                
        return Requisicao.post('usuario/mudarSenha', dados);
    }    
}

export default UsuarioService;